import { connectWithHammock } from 'hammock';
import { ENDPOINTS } from 'site-constants';

export interface Sensitive {
  apiKey: string;
  applicationId: number;
  clientToken: string;
  id: number;
}

export type Senstitives = Sensitive[];

export const withSensitives = connectWithHammock(({ applicationId }) => ({
  resourceName: 'sensitives',
  endpoint: ENDPOINTS.applicationSensitives,
  query: { finder: 'byApplicationId', id: applicationId },
}));
